import { render, staticRenderFns } from "./ModalProjectSelectBasic.vue?vue&type=template&id=2b3a995b&scoped=true"
import script from "./ModalProjectSelectBasic.vue?vue&type=script&lang=js"
export * from "./ModalProjectSelectBasic.vue?vue&type=script&lang=js"
import style0 from "./ModalProjectSelectBasic.vue?vue&type=style&index=0&id=2b3a995b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3a995b",
  null
  
)

export default component.exports